import { css } from '@emotion/core';

import { SPACE_COMFORTABLE } from '@/styles';

import { sharedCardStyles, LARGE_CARD_HEIGHT, LARGE_CARD_WIDTH } from './styles';

export const root = [
  sharedCardStyles,
  // TODO: Remove the `max-width` rule when we fix up the page-level
  // layout as we shouldn't be declaring this to a nested component.
  css`
    box-sizing: border-box;
    width: ${LARGE_CARD_WIDTH}px;
    min-height: ${LARGE_CARD_HEIGHT}px;
  `,
];

export const contentGrid = css`
  display: grid;
  gap: ${SPACE_COMFORTABLE}px;
  grid-template-columns: minmax(280px, auto) 1fr;
  padding: ${SPACE_COMFORTABLE}px;
`;

export const errorGridItem = css`
  align-self: center;
`;

export const compactCardStyles = css`
  border: none;
  min-height: auto;
  & > div {
    padding: 0;
  }
`;

export const responsiveCardStyles = css`
  width: calc(100% - 100px);
  max-width: auto;
  margin-left: -40px; // visiually center the graph since the right vertical ticks are not count in width
`;

export const responsiveGroupCardStyles = css`
  width: calc(100% - 10px);
  max-width: auto;
`;
